import {Injectable} from "@angular/core";
import {AngularFireDatabase} from "angularfire2/database/database";
// Http:
import {Http, Headers} from '@angular/http';
import { HttpClient } from '@angular/common/http';
// importando MAP no como objeto!
import 'rxjs/add/operator/map';
import { AngularFireAuth } from "angularfire2/auth";
import { AutorizacionService } from "./autorizacion.service";
import { User } from "@firebase/auth-types";
import 'rxjs/add/operator/map';

@Injectable()
// Servicio para lugares
export class LugaresService{
    lugaresSocket:any=null;
    // TODO: refactor (armado de la path)   
    pathRequest:any=null;
    respuestaAuth:any=null;
    flagUserSession:boolean=false;
    API_ENDPOINT='https://platzi-square-jdiaz.firebaseio.com';


    lugares:any=[
        {id:1,nombre:'negocio 1', active: true, cercania:1, distancia: 1.2, plan:'pagado', descripcion:'desc'},
        {id:2,nombre:'negocio 2', active: false, cercania:3, distancia: 1.5, plan:'gratis', descripcion:'desc'},
        {id:3,nombre:'negocio 3', active: true, cercania:1, distancia: 5, plan:'pagado', descripcion:'desc'},
        {id:4,nombre:'negocio 4', active: false,cercania:2, distancia:7, plan:'gratis', descripcion:'desc'}
    ];

    // constructor
    constructor(private afDB:AngularFireDatabase, private http:Http, private autorizador:AutorizacionService){

    }
    //constructor(){}

    // obtener todos
    //public getLugares(){
    public getLugares(){
        // TODO: refactor (diferentes mecanismos para retornar en orden de enseñanza)
        //return this.lugares;        
        /* comentado
        Llamados universales
         - mediante el llamado directamente a lugares:
         return this.http.get(this.API_ENDPOINT+'/lugares.json')

         - Llamados universales por si hay más entidades creadas y requeridas
        */
        //return this.http.get(this.API_ENDPOINT+'/lugares.json');      
        this.autorizador.isLogged()
        .subscribe((res)=>{
            //console.log("res :: ",<User[]>res.toJSON())
            //this.respuestaAuth=<User[]>res.toJSON();
            this.respuestaAuth=res;
            //console.log(this.respuestaAuth.uid+ ' plan b:')

            if(this.respuestaAuth!=null){
                this.flagUserSession=true;
                console.log("VERDADERO!!!")                
            }
        },(error)=>{
            console.log(error)
        })
        //  TODO: refactor (validacion public/private)

        console.log('RESULTADO GENERAL ====> '+this.flagUserSession);

        if(this.flagUserSession){
            // Flujo normal
            let ls:any=null;
            if(window.localStorage){
                ls = localStorage.getItem("firebase:authUser:AIzaSyAYTMYcY_VWQghFe-575OXWlXi4Zr7c_PE:platzi-square-jdiaz")
                ls = JSON.parse(ls);
                console.log(ls.stsTokenManager.accessToken)
                console.log('si local storage')
            }else{
                console.log('no local storage')
            }

            // setee variable path
            this.pathRequest=this.API_ENDPOINT+'/.json?auth='+ls.stsTokenManager.accessToken;
        }else{
            // setee variable path
            this.pathRequest=this.API_ENDPOINT+'/.json'
        }
        //return this.http.get(this.API_ENDPOINT+'/.json?auth='+ls.stsTokenManager.accessToken)
        /*
        return this.http.get(this.pathRequest)
                
                .map((resultado)=>{
                    const data = resultado.json().lugares;
                    return data;
                }, (errpr)=>{
                    console.log("Pero que Demonios!!")
                })
        */  
        return this.afDB.list('lugares/');                
        // TODO: descomentado
        //return this.httpClient.get(`${this.API_ENDPOINT}/lugares.json?auth=${idToken}`);
        // FINAL comentado

        //public getLugares(){ return this.afDB.list(‘lugares’).valueChanges(); }
    }
    // buscar un lugar
    public buscarLugar(id){
        return this.lugares.filter((lugar)=>{
            return lugar.id==id
        })[0] || null;
    }

    // TODO: refactor-ok
    // guardar lugar
    public guardarLugar(lugar){
        debugger;
        console.log('::: from service :::');
        console.log(lugar);

        // TODO: activee ===============================================
        // guardando en Firebase
        this.afDB.database.ref('lugares/'+lugar.id).set(lugar);
        const headers=new Headers({"Content-type":"application/json"});
        // FINAL: active ================================================

        // Flujo normal
        let ls:any=null;
        if(window.localStorage){
            ls = localStorage.getItem("firebase:authUser:AIzaSyAYTMYcY_VWQghFe-575OXWlXi4Zr7c_PE:platzi-square-jdiaz")
            ls = JSON.parse(ls);
            console.log(ls.stsTokenManager.accessToken)
            console.log('si local storage')
        }else{
            console.log('no local storage')
        }        
        
        // TODO: refactor - 23-03-2018 - 
        //return this.http.post(this.API_ENDPOINT+'/lugares.json?auth='+ls.stsTokenManager.accessToken,lugar, {headers:headers})
        return true;
        // TODO: pendiente (res validation )
    }

    public editarLugar(lugar){
        console.log('::: from service :::');
        console.log(lugar);
        // guardando en Firebase
        //const dbref = this.afDB.database.ref('lugares/'+lugar.id).set(lugar);
        const dbref = this.afDB.database.ref('lugares/'+lugar.id)
        //firebase.database().ref('users/'+userid);
        dbref.update(lugar);
        //const headers=new Headers({"Content-type":"application/json"});
        //return this.http.post(this.API_ENDPOINT+'/lugares.json', lugar, {headers:headers})
        return true;
        // TODO: pendiente (res validation )
    }

    // Obtener Geodata
    /* Mandar a llamar antes de crear el recrod */
    public obtenerGeodata(direccion){
        //http://maps.google.com/maps/api/geocode/json?address=78-43+diagonal+70f,+Bogota,Colombia
        if (window.location.protocol != "https:") {
            console.log("PROD")
        } else{
            console.log("LOCAL")
        }
        return this.http.get('https://maps.google.com/maps/api/geocode/json?address=' + direccion)
    }




















    // Get Lugar  HTTP
    public getLugar(id){
        let res:any;
        let pathLocal:any;
        // Flujo normal
        let ls:any=null;
        if(window.localStorage){
            ls = localStorage.getItem("firebase:authUser:AIzaSyAYTMYcY_VWQghFe-575OXWlXi4Zr7c_PE:platzi-square-jdiaz")
            ls = JSON.parse(ls);
            console.log(ls.stsTokenManager.accessToken)
            console.log('si local storage')
            pathLocal=this.API_ENDPOINT + '/.json?auth='+ls.stsTokenManager.accessToken;
        }else{
            console.log('no local storage')
            pathLocal=this.API_ENDPOINT + '/lugares.json';
        }        

            //?auth='+ls.stsTokenManager.accessToken
            //return this.http.get(pathLocal).

        
        let resHttp1:any;

        /*
        resHttp1 = this.http.get(pathLocal).
            map((resultado) => {
                const data = resultado.json().lugares;
                return data;
            });
        */
        let rest2:any=null;
        //rest2=this.buscarLugar(id);

        let res3:any=null;
        let objeto:any={}
        /*
        res3=this.afDB.object('lugares/'+id.toString()).valueChanges().map((res)=>{
            objeto=res
        })
        */
        


        //this.afDB.object('lugares/'+id);
        //res=this.afDB.object(`lugares/${id}`);
        /*
        res=this.afDB.object('lugares/'+id);
       
        
        return res;
        */
        //res3=this.afDB.object('lugares/'+id);
        debugger;
        return this.afDB.object('lugares/'+id); /*res3;*/
        //return this.lugaresSocket.object('lugares/'+id);
    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/services/lugares.service.ts